import moment from "moment";

const momentize = function convertStringToMoment(date) {
	/*
        Converts a date string to a moment.
    */

	if (typeof date !== "string") {
		return date;
	}

	const hasUtcOffset = date.split("+").length > 1;
	const hasTimezone = date.slice(-1).toUpperCase() === "Z";

	const isodate = hasTimezone || hasUtcOffset ? date : `${date}Z`;
	return moment(isodate);
};

export default momentize;
